import { useState } from 'react'

import { FormField, Search } from '@domain-group/suit-theme'

import searchFn from '@functions/search'

import type { ProductResult } from '@modals/NewOrderModal/hooks/useNewOrder'

type SearchData = {
  results: ProductResult[],
}

const mapResults = (data: SearchData) => {
  const { results } = data

  if (!results.length){
    return {}
  }

  const groups = results.reduce((acc, result: ProductResult) => {
    const {
      product_id, product_title, provider_title, service_id, service_title,
    } = result

    // @ts-expect-error TS7053
    if (!acc[service_id]){
      // @ts-expect-error TS7053
      acc[service_id] = {
        items: [],
        key: service_id,
        title: service_title,
      }
    }

    // @ts-expect-error TS7053
    acc[service_id].items.push({
      ...result,
      key: product_id,
      secondaryText: `${provider_title}`,
      text: product_title,
    })

    return acc
  }, {})

  const mapped = {
    groups: Object.values(groups),
  }

  return mapped
}

interface ProductSearchProps {
  agencyId: number,
  callbacks: {
    selectItem: (result: ProductResult) => void,
  },
}

const ProductSearch = (props: ProductSearchProps) => {
  const {
    agencyId,
    callbacks: {
      selectItem,
    },
  } = props

  const [searchString, setSearchString] = useState('')

  return (
    <FormField label="Search Products">
      <Search
        callbacks={{
          onChange: (value: string) => setSearchString(value),
          // @ts-expect-error TS2322
          search: searchFn,
          // @ts-expect-error TS2322
          selectItem,
          // @ts-expect-error TS2322
          mapResults,
        }}
        debounceInterval={300}
        endpoint={`agencies/${agencyId}/product_search.json`}
        forwardProps={{
          closeOnSelect: true,
          disabled: false,
          setStringOnSelect: true,
          showOnFocus: true,
        }}
        value={searchString}
      />
    </FormField>
  )
}

export default ProductSearch
